import { createCodedError } from '~/common/errors/CodedError';
import { JsonApiErrorResponse } from '~/redux/api/ApiTypes';
import { HttpValidationError } from '~/redux/api/types/sylvanus/internal';
import { testIsAxiosError } from '~/redux/api/utils';
import { esignature } from '~/services/serviceInstances';

export interface Request {
  integrationId: string;
}

export type DeleteEsignatureIntegrationResponse = void;

type ErrorResponse = JsonApiErrorResponse | HttpValidationError;

export const deleteEsignatureIntegration = async (
  request: Request,
): Promise<DeleteEsignatureIntegrationResponse> => {
  try {
    await esignature.remove(`/integrations/${request.integrationId}`);
  } catch (error) {
    if (testIsAxiosError<ErrorResponse>(error) && error.response) {
      const { status } = error.response;
      const responseData = error.response.data;

      if (
        status === 422 &&
        'detail' in responseData &&
        Array.isArray(responseData.detail)
      ) {
        const validationError = responseData.detail[0];
        const message = validationError?.msg || 'Validation error';
        throw createCodedError({
          message,
          statusCode: status,
          title: 'Validation Error',
        });
      }

      if ('errors' in responseData && Array.isArray(responseData.errors)) {
        const errorResponse = responseData.errors[0];
        throw createCodedError({
          message: errorResponse.detail ?? errorResponse.title,
          statusCode: errorResponse.status,
          title: errorResponse.title,
        });
      }
    }
    throw error;
  }
};
